var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('v-container',{staticClass:"center"},[_c('h2',{staticClass:"text-center"},[_vm._v(" 404 Page Not Found ")])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }